var React = require('react');
var { connect } = require('react-redux');
var { useLocation, useNavigate } = require('react-router-dom');
var BaseComponent = require('BaseComponent');
var DashboardContent = require('DashboardContent');
var { FIELD_VIEW_PATH } = require('../general/viewPaths');
var UpdateFieldModal = require('UpdateFieldModal');
var $ = require('jquery');
var farmingUnitManager = require('farmingUnitManager');
var FieldsContainer = require('FieldsContainer');
var fieldManager = require('fieldManager');
var distributionActions = require('distributionActions');
var distributionManager = require('@managers/distributionManager');
var ApprovalModal = require('ApprovalModal');
var AlertModal = require('AlertModal');
var ReportIssueModal = require('ReportIssueModal');
var Spinner = require('../general/Spinner.jsx');
var dayjs = require('../../utils/dayjsConfig');
const { withTranslation } = require('react-i18next');
var { parseQueryParams, clearQueryParams, getQueryParam } = require('helpers');
var { trackPageView } = require('Utils');

class Dashboard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      archiveMode: false,
      editFieldModalKey: Date.now(),
      urlParamsProcessed: false,
    };

    this.setArchiveMode = this.setArchiveMode.bind(this);
    this.onPolygonClick = this.onPolygonClick.bind(this);
    this.onDeleteApprovalClick = this.onDeleteApprovalClick.bind(this);
    this.refreshDistributions = this.refreshDistributions.bind(this);

    this.onCreateNewField = this.onCreateNewField.bind(this);

    this.refreshView = this.refreshView.bind(this);
    this.onArchive = this.onArchive.bind(this);
    this.processUrlParams = this.processUrlParams.bind(this);

    // update data every 3 hours (the number is in milliseconds)
    setInterval(this.refreshDistributions, 10800000);
    this.openEditFieldModal = this.openEditFieldModal.bind(this);
  }

  processUrlParams() {
    if (this.state.urlParamsProcessed) {
      return;
    }

    const urlParams = parseQueryParams(this.props.location);
    const distributionId = urlParams.get('distributionId');
    const farmingUnitId = urlParams.get('farmingUnitId');
    const fieldId = urlParams.get('fieldId');

    // Only process if URL parameters are present and distributions are loaded
    if (distributionId && farmingUnitId && this.props.distributions) {
      // Track URL parameter entry in Mixpanel
      mixpanel.track('Dashboard Accessed via URL', {
        'Distribution ID': distributionId,
        'Farming Unit ID': farmingUnitId,
        'Field ID': fieldId || 'Not specified',
        'Has Field ID': !!fieldId,
        origin: getQueryParam(this.props.location, 'origin'),
      });

      this.props.dispatch(
        distributionActions.selected_entities_by_id(
          distributionId,
          farmingUnitId,
          fieldId,
        ),
      );

      // Clear URL parameters after processing
      clearQueryParams(
        this.props.navigate,
        this.props.location,
        FIELD_VIEW_PATH,
      );
      this.setState({ urlParamsProcessed: true });
    }
  }

  componentDidMount() {
    trackPageView('Dashboard');
    this.processUrlParams();
  }

  refreshDistributions() {
    this.props.dispatch(distributionActions.load_distributions(true));
  }

  componentDidUpdate(prevProps, prevState) {
    // Process URL params when distributions are loaded
    // prevProps = previous props, this.props = current props
    if (!prevProps.distributions && this.props.distributions) {
      this.processUrlParams();
    }

    if (
      (prevProps.selected_field &&
        this.props.selected_field &&
        JSON.stringify(prevProps.selected_field) !=
          JSON.stringify(this.props.selected_field)) ||
      (!prevProps.selected_field && this.props.selected_field) ||
      prevProps.loadHistoryStatus.status == 'success'
    ) {
      this.refreshView();
      mixpanel.track('Dashboard Load');
    }
  }

  refreshView() {
    var current_selected_field = this.props.selected_field;
    if (current_selected_field) {
      this.updateMap(current_selected_field);
      this.updateGauge(current_selected_field);
    } else {
      // clear views
      this.updateMap(undefined);
      this.updateGauge(undefined);
    }
  }

  updateMap(field) {
    if (this.props.selected_farming_unit) {
      var selected_field_index = field ? field.id : '';

      if (this.custom_map) {
        let fieldsState = this.props.archiveMode ? 'archive' : 'active';

        var all_areas = farmingUnitManager.all_farming_unit_areas(
          this.props.selected_farming_unit,
          selected_field_index,
          fieldsState,
        );
        var all_markers = farmingUnitManager.all_farming_unit_markers(
          this.props.selected_farming_unit,
          selected_field_index,
          fieldsState,
        );

        this.custom_map.invalidate(all_areas, all_markers);
      }
    }
  }

  updateGauge(field) {
    var recommendation_amount = -1;
    var stress_level = 0;
    var recommendation_date_text = '01/01/1970';

    if (field) {
      let fieldDataItems = fieldManager.getFieldItems(field);

      recommendation_amount = fieldDataItems.irrigationDataItem.value;
      var recommendation_date = dayjs.unix(
        fieldDataItems.irrigationDataItem.date,
      );
      recommendation_date_text = recommendation_date.format('DD/MM/YYYY');
      stress_level = fieldDataItems.stressDataItem.value;
    }
  }

  setArchiveMode() {
    this.setState({ archiveMode: !this.state.archiveMode });
  }

  onPolygonClick(polygon_id) {
    var current_selected_field =
      this.props.selected_farming_unit?.fields?.[polygon_id];
    if (!current_selected_field) {
      return;
    }

    this.props.dispatch(
      distributionActions.selected_entities(
        null,
        null,
        current_selected_field,
        null,
      ),
    );
  }

  onCreateNewField() {
    if (
      this.props.selected_farming_unit != null &&
      this.props.selected_farming_unit.role.toLowerCase() === userRoles.ADMIN
    ) {
      this.openEditFieldModal();
    }
  }

  onDeleteApprovalClick(objects) {
    this.props.dispatch(
      distributionActions.delete_field(objects[0], objects[1], objects[2]),
    );
  }

  onArchive(objects) {
    this.props.dispatch(
      distributionActions.update_field(objects[0], objects[1], {
        ...this.props.selected_field,
        settings: {
          ...this.props.selected_field.settings,
          field_state: 'archive',
        },
      }),
    );
    mixpanel.track('Field moved to archive', {
      'Field ID': this.props.selected_field.id,
      'Field Name': this.props.selected_field.name,
    });
  }

  openEditFieldModal() {
    this.setState({ editFieldModalKey: Date.now() }, () => {
      $('#fieldModalId').modal('show');
    });
  }

  render() {
    const { t } = this.props;

    // While the selected distribution is still a skeleton (its full tree is
    // loading after an optimistic switch), the field-dependent content
    // (sidebar field list + dashboard graphs/map) would read fields/sensors
    // that don't exist yet. Show a spinner in their place until the full tree
    // lands. A cold start has no selected distribution at all yet, which looks
    // the same to the user, so that counts as loading too. The exception is a
    // failed load, where nothing further is coming and a spinner would spin
    // forever — that includes an account with no distributions.
    const isSelectedTreeLoading =
      this.props.all_distribution_load_status?.status !== 'fail' &&
      (!this.props.selected_distribution ||
        !distributionManager.isFullDistributionTree(
          this.props.selected_distribution,
        ));

    return (
      <div className='main-screen'>
        <UpdateFieldModal
          key={this.state.editFieldModalKey}
          modalId={'fieldModalId'}
        />
        <ApprovalModal
          modalId={'deletionApprovalModalId'}
          message={t('edit_field_delete_field_message')}
          onApprove={this.onDeleteApprovalClick}
        />
        <ApprovalModal
          modalId={'approvalModalId'}
          message='Are you sure you want to archive this field?'
          onApprove={this.onArchive}
        />
        <AlertModal
          modalId={'deleteAlertModalId'}
          message={this.props.field_actions.error}
          onDismiss={this.props.clear_field_action}
        />
        <ReportIssueModal modalId={'reportIssueModalId'} />

        {isSelectedTreeLoading ? (
          <div
            className='d-flex justify-content-center align-items-center flex-fill'
            style={{
              minHeight: '80vh',
              backgroundColor: 'var(--color-grey-96)',
            }}
          >
            <Spinner size='medium' />
          </div>
        ) : (
          <div className='d-flex '>
            <div className='d-none d-xl-block' style={{ width: '355px' }}>
              <div
                style={{
                  width: '355px',
                  height: '100%',
                  position: 'fixed',
                  boxShadow:
                    '0px 4px 8px 0px rgba(145, 157, 180, 0.18), 0px 1px 4px 0px rgba(146, 158, 181, 0.10)',
                }}
              >
                <FieldsContainer
                  onCreateNewField={this.onCreateNewField}
                  archiveMode={this.state.archiveMode}
                  setArchiveMode={this.setArchiveMode}
                />
              </div>

              <div
                className='d-none d-xl-block'
                style={{ width: '355px' }}
              ></div>
            </div>

            <div
              className='flex-fill pl-xl-4 pr-xl-4 pb-xl-4 pt-xl-3 p-2'
              style={{ backgroundColor: 'var(--color-grey-96)' }}
            >
              <DashboardContent archiveMode={this.state.archiveMode} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    selected_distribution:
      state.distribution_data.selected_entities.distribution,
    all_distribution_load_status:
      state.distribution_data.all_distribution_load_status,
    selected_farming_unit:
      state.distribution_data.selected_entities.farming_unit,
    selected_field: state.distribution_data.selected_entities.field,
    field_actions: state.distribution_data.field_actions,
    loadHistoryStatus: state.distribution_data.field_load_history,
    userData: state.authentication_data.user_data,
    configuration_data: state.configuration_data,
    distributions: state.distribution_data.distributions,
  };
};

const ConnectedDashboard = connect(mapStateToProps)(
  withTranslation()(Dashboard),
);

// Wrapper component to provide router props using hooks
const DashboardWithRouter = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <ConnectedDashboard {...props} location={location} navigate={navigate} />
  );
};

module.exports = DashboardWithRouter;

/*

*/
